var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"unitEntryByPkb",staticStyle:{"min-height":"300px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }